import Axios from "axios";

type Response = {
  users: {
    primaryEmail: string;
    name: {
      fullName: string;
    };
  }[];
};

type Directory = {
  name: string;
  email: string;
}[];

export async function getDirectory(
  access_token: string,
  search: string,
  key: "email" | "name" = "email",
  count: number = 10
): Promise<Directory> {
  try {
    const { data } = await Axios.get<Response>(
      `https://www.googleapis.com/admin/directory/v1/users`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        params: {
          customer: "my_customer",
          maxResults: count,
          orderBy: key === "name" ? "givenName" : key,
          viewType: "domain_public",
          query: `${search.replace("'","\\'")}`,
        },
      }
    );

    return data.users.map((user) => ({
      email: user.primaryEmail,
      name: user.name.fullName,
    }));
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.errorCode);
    } else {
      throw error;
    }
  }
}
